<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- table actions -->
      <div class="px-5 py-5">
        <!-- top search bar -->
        <div class="pb-5 d-flex">
          <div class="form-input-group flex-grow-1 mr-5">
            <div class="prepend-icon" style="top: 45%;">
              <v-icon>search</v-icon>
            </div>
            <input
              type="text"
              class="pl-42px"
              placeholder="搜尋"
              v-model="filter.keyword"
            />
          </div>
          <button class="btn btn-primary w-88px" @click="search">搜尋</button>
        </div>

        <!-- second filter actions -->
        <div class="pb-5 d-flex">
          <DateFilter
            class="w-220px mr-5"
            :dateOfRegisterFilter.sync="filter.createdAtRange"
          ></DateFilter>
          <SimpleSelectWithSearch
            class="mr-5"
            buttonPlaceholder="篩選國家別"
            inputPlaceholder="搜尋國家"
            :isOnlyShowButtonPlaceholder="true"
            :selectedValue.sync="filter.country"
            :options="countryOptions"
            item-value="country"
            item-text="country"
          ></SimpleSelectWithSearch>
          <SimpleSelect
            class="mr-5"
            buttonPlaceholder="篩選篩選生日月份"
            modalWidth="160px"
            :isOnlyShowButtonPlaceholder="true"
            :selectedValue.sync="filter.month"
            :options="monthOptions"
          ></SimpleSelect>
          <SimpleSelectWithSearch
            class="mr-5"
            buttonPlaceholder="篩選註冊產品類別"
            :isOnlyShowButtonPlaceholder="true"
            :selectedValue.sync="categoryOfPorductFilter"
            :options="['Category1', 'Category2', 'Category3', 'Category11']"
          ></SimpleSelectWithSearch>
          <SimpleSelect
            class="mr-5"
            buttonPlaceholder="篩選年齡區間"
            modalWidth="160px"
            :isOnlyShowButtonPlaceholder="true"
            :selectedValue.sync="filter.age"
            :options="ageOptions"
          ></SimpleSelect>
        </div>

        <!-- filter condition -->
        <div
          class="d-flex"
          v-if="
            filter.country != null ||
            filter.month != null ||
            categoryOfPorductFilter != null ||
            filter.age != null
          "
        >
          <div
            class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
          >
            篩選條件：
          </div>
          <div class="flex-wrap">
            <!-- filter.country -->
            <v-chip
              v-if="filter.country != null"
              close
              class="ml-5 mb-2"
              @click:close="filter.country = null"
            >
              {{ filter.country }}
            </v-chip>

            <!-- filter.monthy -->
            <v-chip
              v-if="filter.month != null"
              close
              class="ml-5 mb-2"
              @click:close="filter.month = null"
            >
              {{ monthName }}
            </v-chip>

            <!-- categoryOfPorductFiltere -->
            <v-chip
              v-if="categoryOfPorductFilter != null"
              close
              class="ml-5 mb-2"
              @click:close="categoryOfPorductFilter = null"
            >
              {{ categoryOfPorductFilter }}
            </v-chip>

            <!-- filter.age -->
            <v-chip
              v-if="filter.age != null"
              close
              class="ml-5 mb-2"
              @click:close="filter.age = null"
            >
              {{ ageName }}
            </v-chip>
          </div>
        </div>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <!--<div v-if="lengthOfisCheckedList > 0"-->
               <!--class="form-item d-flex align-center px-5 h-60px batch">-->
            <!--<h5 class="col-checkbox">-->
              <!--<v-checkbox-->
                <!--v-model="checkAllStatus"-->
                <!--:indeterminate="indeterminate"-->
                <!--@click="changeAllCheckbox"-->
              <!--&gt;</v-checkbox>-->
            <!--</h5>-->
            <!--<h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>-->
            <!--<div>-->
              <!--<button class="btn btn-danger mr-10px" @click="multiDelete">-->
                <!--<v-icon color="white" class="mr-2">delete</v-icon>-->
                <!--<span>刪除</span>-->
              <!--</button>-->
            <!--</div>-->
            <!--<div>-->
            <!--<button class="btn mr-10px" @click="changePublish(true)">設為顯示</button>-->
            <!--</div>-->
            <!--<div>-->
            <!--<button class="btn" @click="changePublish(false)">設為隱藏</button>-->
            <!--</div>-->
          <!--</div>-->
          <tr>
            <!--<th>-->
              <!--<v-checkbox-->
                <!--v-model="checkAllStatus"-->
                <!--:indeterminate="indeterminate"-->
                <!--@click="changeAllCheckbox"-->
              <!--&gt;</v-checkbox>-->
            <!--</th>-->
            <th class="text-left">名字</th>
            <th class="text-left">姓氏</th>
            <th class="text-left">帳號(Email)</th>
            <th class="text-left">國別/區域</th>
            <th class="text-left">註冊產品數</th>
            <th class="text-left">報修次數</th>
            <th class="text-left">註冊日期</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in members"
            :key="item.id"
            @click="toMemberInfo(item.id)"
          >
            <!--<td>-->
              <!--<v-checkbox v-model="item.isChecked"></v-checkbox>-->
            <!--</td>-->
            <td>{{ item.first_name }}</td>
            <td>{{ item.last_name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.country }}</td>
            <td>{{ item.product_registrations_count }}</td>
            <td>0</td>
            <td>{{ item.created_at }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- table footer -->
      <Pagination @handleNextPreEvent="getMembers" model="member"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// Filter
import DateFilter from '@/components/F-1a__ADATA-members_Filter-StartEndDate.vue';
import SimpleSelectWithSearch from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import SimpleSelect from '@/components/Selection/SimpleSelect.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    DateFilter,
    SimpleSelectWithSearch,
    SimpleSelect,
    Pagination,
  },
  data: () => ({
    // filter
    categoryOfPorductFilter: null,
  }),
  computed: {
    ...mapState('member', [
      'members',
      'filter',
      'monthOptions',
      'ageOptions',
      'countryOptions',
    ]),
    ageName() {
      return this.ageOptions.find((o) => o.value === this.filter.age).title;
    },
    monthName() {
      return this.monthOptions.find((o) => o.value === this.filter.month).title;
    },
  },
  methods: {
    ...mapActions('member', {
      getMembers: 'find',
      setFilter: 'setFilter',
    }),
    toMemberInfo(id) {
      this.$router.push({
        name: 'AdataMemberInfo',
        params: { id },
      });
    },
    search() {
      this.setFilter(this.filter);
      this.getMembers();
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-name {
    width: 130px;
    margin-right: 20px;
  }
  .col-first-name {
    width: 130px;
    margin-right: 20px;
  }
  .col-email {
    width: 250px;
    margin-right: 10px;
  }
  .col-nation {
    width: 150px;
    margin-right: 20px;
  }
  .col-count-of-registered-product {
    width: 75px;
    text-align: right;
    margin-right: 20px;
  }
  .col-count-of-fix {
    width: 60px;
    text-align: right;
    margin-right: 20px;
  }
  .col-date-of-register {
    width: 75px;
    text-align: right;
  }
}
</style>
